import React, {useState} from "react";
import css from "./index.module.scss";
import DefaultLayout from "layouts/default";
import Button from "@/components/button";
import { useEffect } from "react";
import { sendDatalayerEvent } from "@/scripts/utils";


export default function ThankYouPage() {
  useEffect(() => {
    sendDatalayerEvent("vendorConversion", "DL - Vendor Conversion");
  }, []);


  return <DefaultLayout
    title="Vendor Account | Lazy Prompts"
    description="Sell your AI prompts on Lazy Prompts."
    light
  >
    <section className={`light ${css.thanks}`}>
      <div className="sectionInner">
        <h2>Success!</h2>
        <p>You are now ready to sell on Lazy Prompts.</p>
        <Button label="Create Listing" href="/account/listings/create"/>
      </div>
    </section>

  </DefaultLayout>;
}
